module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[43]530.16fa8de.woff2";